import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_7j6yttrrz2: FaireBrandEntity = {
  token: "b_7j6yttrrz2",
  type: "brand",
  name: "Tara Kothari",
  avatarUrl:
    "https://cdn.faire.com/fastly/2c887e1c2cf9e400b25e8033a955a9fa9037df8841e20b30cde2100b6f8c5dc4.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a5ba29f3ce6cd65afc3d8a4c27a2f22ae3f955e603295fbc4f13e0ed73f9b8ed.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2c887e1c2cf9e400b25e8033a955a9fa9037df8841e20b30cde2100b6f8c5dc4.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a5ba29f3ce6cd65afc3d8a4c27a2f22ae3f955e603295fbc4f13e0ed73f9b8ed.jpeg",
  location: "Flemington, NJ, USA",
  minimumOrderDollars: 342,
  rating: 5,
  reviewCount: 8,
  isTopShop: true,
  isInsider: true,
  description:
    "Pressing flowers into clay helps me makes sense of the changing seasons around me. \nWorking with seasonal flowers and plants, helps me adjust to my life in the NorthEast part of America. \n\nMy work involves pressing real leaves and flowers in clay. Once they burn out I paint each fossil with underglaze colors and glazes to bring them back to life. \n\nOften times I will incorporate puns and illustrations into my work depicting my love for language and/or places I have been to. \n\nEach piece aspires to bring joy to someone's life, akin to that got walking on a mountain trail on a spring morning and occasionally peering into a clearing to see a special flower that would probably be in a manicured garden. :) \n\nCome-- Walk the trail with my work. Allow yourself to stop and enjoy the wildflowers, the sound of the rustling leaves and smile for the things you might normally overlook. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-04-19T21:45:00.940Z",
    importedBy: "entity-db-cli",
  },
};
